import * as React from 'react'
import { withRouter } from 'next/router'
import { TrackListItemComponent } from '@components/Track/TrackListItem'
import DiscoverLayout from '@components/Discover/DiscoverLayout'
import type { TrackPropsType, PopularPropsType } from '../../models/Track'
import { getPopularPropsAsync } from '../../models/Track'
import { PageTitle } from '@components/shared/PageTitle'
import styled from 'styled-components'
import { config } from 'react-awesome-styled-grid'
import { colors } from '@components/shared/colors'
function PopularTracks (props: PopularPropsType): React.ReactNode {
  return (
    <DiscoverLayout title={`Listen to Popular Audiobooks on Dipsea`} canonicalUrl={'https://www.dipseastories.com/chapters/popular'}>
        <PageTitle title={props.title}/>
          {props.tracks.map((track: TrackPropsType): React.ReactNode => (
            <SectionDivider key={track.id}>
              <TrackListItemComponent {...track}/>
            </SectionDivider>
          ))}
    </DiscoverLayout>
  )
}
export default withRouter(PopularTracks as any) as any

type ContextType = {
  params: {
    slug: string
  }
}
export async function getStaticProps (
  _context: ContextType
): Promise<{ props: PopularPropsType }> {
  const props = await getPopularPropsAsync()
  return { props }
}

const SectionDivider = styled.div<any>`
  padding: 15px 0;
  border-bottom: 1px solid ${colors.white25};
  ${(props: any): any => config(props).media.md`
    padding: 30px 0;
  `}
`
